export default "__VITE_ASSET__CBtDS3xJ__"